import { atom } from 'jotai';
import { mqttClientAtom } from '../connection/mqttConnectionAtom';
import { setDebugLabels } from '../utils/atomUtils';
import {
  subscriberSetAtomFamily,
  removeSubscriberAtom,
} from './subscriptionAtoms';
import {
  isValidSubscriber,
  isLastSubscriber,
  handleLastSubscriberUnsubscribe,
  logSubscriberRemoval,
} from '../utils/subscriptionUtils';

export const unsubscribeFromTopicAtom = atom(
  null,
  async (
    get,
    set,
    {
      topic,
      subscriberId,
    }: {
      topic: string;
      subscriberId: string;
    },
  ) => {
    const client = get(mqttClientAtom);
    const currentSubscribers = get(subscriberSetAtomFamily(topic));

    if (!isValidSubscriber(currentSubscribers, subscriberId)) {
      return;
    }

    const shouldUnsubscribeFromTopic = isLastSubscriber(currentSubscribers);
    set(removeSubscriberAtom, { topic, subscriberId });

    if (shouldUnsubscribeFromTopic) {
      await handleLastSubscriberUnsubscribe(client, topic);
    } else {
      logSubscriberRemoval(topic, subscriberId, currentSubscribers.size - 1);
    }
  },
);

setDebugLabels({
  unsubscribeFromTopicAtom,
});
